import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

const resolveEmpresaId = async () => {
    const { user } = getAuthContext();

    if (user?.idEmpresa) {
        return user.idEmpresa;
    }

    if (user?.idSucursal) {
        const sucursalResponse = await getAxios().get(`/api/sucursales/${user.idSucursal}`);
        return sucursalResponse.data?.data?.idEmpresa ?? 1;
    }

    return 1;
};

export const SucursalService = {
    getAll: async () => {
        const idEmpresa = await resolveEmpresaId();
        const response = await getAxios().get(`/api/sucursales/empresa/${idEmpresa}`);
        return response.data;
    },
    
    getByEmpresa: async (idEmpresa) => {
        const response = await getAxios().get(`/api/sucursales/empresa/${idEmpresa}`);
        return response.data;
    },

    create: async (sucursal) => {
        const response = await getAxios().post('/api/sucursales', sucursal);
        return response.data;
    },

    update: async (id, sucursal) => {
        const response = await getAxios().put(`/api/sucursales/${id}`, sucursal);
        return response.data;
    },

    delete: async (id) => {
        const response = await getAxios().delete(`/api/sucursales/${id}`);
        return response.data;
    }
};
